import { SxProps, Theme } from "@mui/material/styles";

export const dialogPaperStyles = (
  backgroundColor: string,
): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
  maxHeight: "100dvh",
  borderRadius: 0,
  overflow: "hidden",
  backgroundColor,
});

export const dialogContentStyles: SxProps<Theme> = {
  p: 0,
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  height: "100%",
  overflow: "hidden",
  "&.MuiDialogContent-root": { paddingTop: 0 },
};
